import React, {
    Component
} from 'react'
import {
    Link,
    NavLink
} from 'react-router-dom'

import fetch from '../utils/fetch';
import { actionTypes } from '../constants';

import Promise from 'bluebird';

import Spinner from '../utils/spinner';

import _ from 'lodash-joins';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import XSwitch from '../widgets/x-switch';

import { parseCsv } from '../utils/csv';
import { Api as UserApi } from '../sagas/users';


class ModalUploadCsvUsers extends Component {
    constructor() {
        super()

        this.state = {
            onboardingEmailSent: false,
            error: null,
            csv: null,
            step: 1,
            apiErrors: [],
        }
        this.uploadRef = null;
    }

    componentWillUnmount(){
        this.props.dispatch({type: actionTypes.DEPARTMENTS_FETCH_ONE, id: this.props.match.params.department_id})
    }

    async componentDidUpdate(prevProps, prevState){
        console.log(this.state.csv);
        if(this.state.csv && prevState.csv !== this.state.csv){
            try {
                const csvJson = await parseCsv(this.state.csv);
                const users = csvJson.map(user=>({
                    ...user,
                    clientId: this.props.match.params.department_id,
                }));
                this.setState({
                    csvJson: csvJson,
                    users: users,
                })
            } catch (err) {
                console.error(err);
                this.setState({
                    error: err.message
                })
            }
        }
    }

    async submitUsers(){
        try{
            Spinner.start();
            this.props.dispatch({
                type: actionTypes.SNACKBAR,
                snackbar: {
                    severity: 'info',
                    text: `Started uploading CSV.`
                }
            });
            await Promise.delay(1000);

            let apiErrors = [];
            let counter = 0;
            for(let user of this.state.users){
                counter += 1;
                console.log(`Submitting user email=${user.email}...`);
                this.props.dispatch({
                    type: actionTypes.SNACKBAR,
                    snackbar: {
                        severity: 'info',
                        text: `Ingesting CSV row ${counter}/${this.state.users.length}...`
                    }
                });
                try {
                    await UserApi.createUser(user);
                } catch (err) {
                    let messages = _.get(err, ['data', 'messages'], []);
                    let invalids = messages.map(m=>_.last(_.get(m, ['path'], null))).filter(f=>f);
                    if(invalids.length){
                        err.pretty = `Row ${counter+1} has invalid fields: ${invalids.join(', ')}`;
                    }else{
                        err.pretty = `Row ${counter+1}: ${_.first(messages)}`
                    }
                    apiErrors.push(err);
                }
            }

            this.setState({
                apiErrors: apiErrors,
                error: apiErrors.length ? 'Some of your rows contained invalid user data. These users were not created.' : null,
                step: apiErrors.length ? 1 : 2
            })
        } catch (err) {
            this.setState({
                error: err.message
            })
        } finally {
            Spinner.stop();
        }
    }

    async handleSubmit(e) {
        console.log(`handleSubmit`);
        e.preventDefault();
        if(this.state.step === 1){
            if(!this.state.csv){
                this.setState({
                    error: 'Please pick a file to upload.'
                })
                return;
            }
            await this.submitUsers();
        }
        if(this.state.step === 2){
            this.props.closeModal();
        }
    }

    render() {
        console.log(this.state);
        console.log(this.props);

        if(!this.props.departments.is_loaded || !this.props.departments.detail){
            return 'Loading...'  // hide while loading
        }

        let department = this.props.departments.detail;

        let validationErrors = [];
        for(let apiError of this.state.apiErrors){
            validationErrors.push(
                <li>{apiError.pretty}</li>
            )
        }

        return (
            <form className="modal-upload-csv-users modal" onSubmit={this.handleSubmit.bind(this)}>
                <input
                    type="file"
                    accept=".csv"
                    ref={ref=>{this.uploadRef = ref}}
                    onChange={e=>{
                        let file = e.target.files[0];
                        this.setState({
                            csv: file
                        })
                    }}
                    style={{display: 'none'}}
                />
                <input type="submit" style={{display: 'none'}}/>
                <div className="modal-header">
                    <div className="modal-title">
                        Upload CSV
                    </div>
                    <a onClick={this.props.closeModal} className="modal-dismiss">
                        <img src={`/dist/assets/img/ic-close.svg`}/>
                    </a>
                </div>
                <div className="modal-content">
                    <div className="instructions">
                        Please upload a CSV with the following columns:
                        <div className="inline-pre">
                            firstname, lastname, email, phone, role 
                        </div>
                    </div>
                    <XSwitch
                        style={{marginTop: '1rem'}}
                        label="Send New Account Email"
                        name="onboardingEmailSent"
                        value={this.state.onboardingEmailSent}
                        handleChange={value=>{this.setState({onboardingEmailSent: value})}}
                    />
                    <FormControl>
                        <div
                            style={{marginTop: '1rem'}}
                            className="button button-gray"
                            onClick={e=>{
                                console.log('import users')
                                this.uploadRef.value = null;
                                this.setState({
                                    csv: null,
                                    error: null,
                                    apiErrors: [],
                                    step: 1
                                });
                                this.uploadRef.click();
                            }}
                        >
                            {this.state.csv ? this.state.csv.name : 'Choose File'}
                        </div>
                    </FormControl>
                    {this.state.error === null ? null : (
                        <div className="error-panel">
                            <div className="error-icon">
                                <img src={`/dist/assets/img/ic-error.svg`} />
                            </div>
                            <div className="error-message">
                                {this.state.error}
                            </div>
                        </div>
                    )}
                    <div className="api-errors">
                        {validationErrors}
                    </div>
                    {this.state.step === 2 ? (
                        <div className="upload-csv-success">
                            <h2>Success</h2>
                            Your CSV was successfully uploaded.
                        </div>
                    ) : null}
                </div>
                <div className="modal-footer">
                    <div onClick={this.handleSubmit.bind(this)} className={`button ${this.state.step === 1 ? 'button-primary' : 'button-gray'}`}>
                        {this.state.step === 1 ? 'Submit' : 'Close'}
                    </div>
                </div>
            </form>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            departments: state.departments,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    }
)(ModalUploadCsvUsers);